import _ from 'underscore';

enum Routes {
    ROOT = '/',
    PRIVACY_POLICY = '/privacy-policy',
    TERMS_AND_CONDITIONS = '/terms-and-conditions',
    ONBOARDING = '/onboarding',
    SESSIONS = '/sessions',

    JOURNALS = '/journals',
    JOURNAL_EDIT = '/journals/:id/',
    COURSES = '/courses',
    KITS = '/kits',
    RESULT_ID = '/sessions/:id/result/:resultID/components/:componentID',
    SETTINGS = '/settings',

    SUMMARY = '/summary',
    COURSE = '/course',
    WAREHOUSING = '/warehousing',
    DISCOUNT_CODES = '/discount-codes',

    SESSION_DETAILS_ID = '/sessions/:id/',
    RESULTS = '/sessions/:id/results/',
    RESULTS_SUMMARY = '/sessions/:id/summary/:collectionID/',
    QUESTIONNAIRE_DETAILS_ID = '/sessions/:id/questionnaire/:questionnaireID',
    JOURNAL_WRITE = '/journals/:id',

    SESSION_OVERVIEW = '/sessions/:id/',
    SESSION_RESULTS = '/sessions/:id/results',
    SESSION_RESULT_ID = '/sessions/:id/results/:resultID',
    SESSION_QUESTIONNAIRES = '/sessions/:id/questionnaires',
    SESSION_QUESTIONNAIRES_ID = '/sessions/:id/questionnaires/:questionnaireID',
    SESSION_JOURNAL = '/sessions/:id/notes',
    REPORTS = '/sessions/:id/reports',
    ASK_AI = '/sessions/:id/ask-ai',

    CUSTOM_SUPPLEMENTS = '/sessions/:id/supplement-providers',
    CUSTOM_SUPPLEMENTS_DETAILS_ID = '/sessions/:id/supplement-providers/:supplementProviderID',

    TERMS_PORTAL = '/portal-terms-and-conditions',

    TRANSACTIONS = '/summary/transactions',
}

export default Routes;

export const publicRoutes = [
    Routes.ROOT,
    Routes.PRIVACY_POLICY,
    Routes.TERMS_AND_CONDITIONS,
    Routes.ONBOARDING,
    Routes.TERMS_PORTAL,
];

export const isPublicRoute = (currentPath: string) => {
    return _.contains(publicRoutes, currentPath);
};

interface IOptions {
    userId?: string;
    collectionId?: number;
}

export const replaceLocation = (route: Routes, options: IOptions | any): Routes => {
    Object.keys(options).forEach((element: IOptions | any) => {
        route = route.replace(`:${element}`, options[element]) as Routes;
    });
    return route as Routes;
};

export enum SSORoutes {
    LOGIN = 'login',
    REGISTER = 'register',
}

export enum RoutesNames {
    HOME = 'Home',
    ONBOARDING = 'Onboarding',
    SESSIONS = 'Sessions',
    SESSION_DETAILS = 'Session Details',
    RESULTS_SUMMARY = 'Results Summary',
    QUESTIONNAIRE_DETAILS = 'Questionnaire Details',
    RESULT = 'Result',
    JOURNALS = 'Journals',
    JOURNAL_EDIT = 'Edit Journal',
    JOURNAL_WRITE = 'Write in Journal',
    KITS = 'Kits',
    SETTINGS = 'Settings',
    TERMS = 'Terms & Conditions',
    PRIVACY_AND_POLICY = 'Privacy Policy',

    SESSION_OVERVIEW = 'Overview',
    SESSION_RESULTS = 'Genotype results',
    SESSION_RESULT_ID = 'Genotype results',
    SESSION_QUESTIONNAIRES = 'Questionnaires',
    SESSION_QUESTIONNAIRES_ID = 'Questionnaires',
    SESSION_JOURNAL = 'Journal',
    REPORTS = 'Pharmaco reports',

    CUSTOM_SUPPLEMENTS = 'Custom supplements',
    CUSTOM_SUPPLEMENTS_DETAILS_ID = 'Supplements',

    ASK_AI = 'Ask AI',
}
